import { columnOptions } from "../constants";

export const mapColumnName = (columnName: string) => {
  const loweredColumnName = columnName.toLowerCase();
  const columnOption = columnOptions.find((c) => c.name.toLowerCase() === loweredColumnName);
  if (!columnOption || !columnOption.propName) return columnName;

  return columnOption.propName;
};
